import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { featchFilterDefectCategory, featchFilterDefectType, featchFilterProduct, fetchStructure, updateTreeStructData } from './thunk'
import { parseTreeToArray } from "../../../helpers/three";
import _ from 'lodash'

/**
 * @interface
 */
const initialState = {
    struct: {
        loading: 'idle',
        entities: [],
        selectedIds: [],
        error: null,
        timeStamp: null,
        tree: null,
    },
    product: {
        loading: 'idle',
        entities: [],
        error: null,
    },
    defectCategory: {
        loading: 'idle',
        entities: [],
        error: null,
    },
    defectType: {
        loading: 'idle',
        entities: [],
        error: null,
    }
}

const filtersSlice = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        setTreeData: ( state, action ) => {
            state.struct.tree = action.payload
        }
    },
    extraReducers: build => {
        // Fetch Structure
        build.addCase(fetchStructure.pending, (state, action) => {
            if ( state.struct.loading === 'idle' ) {
                state.struct.loading = 'loading'
            }
        }).addCase(fetchStructure.rejected, (state, action) => {
            if ( state.struct.loading === 'loading' ) {
                state.struct.loading = 'idle'
                state.struct.error = 'Erro inesperado'
            }
        }).addCase(fetchStructure.fulfilled, (state, action) => {
            if ( state.struct.loading === 'loading' ) {
                state.struct.loading = 'idle'
                state.struct.entities = action.payload.value
                state.struct.timeStamp = _.now()
            }
        })
        // 
        .addCase(updateTreeStructData.fulfilled, (state, action) => {
            state.struct.tree = action.payload
            //console.log(action.payload)
            state.struct.entities = parseTreeToArray(action.payload[0])
        })

        // featchFilterProduct
        .addCase(featchFilterProduct.fulfilled, (state, action) => {
            state.product.entities = action.payload
        })

        // featchFilterDefectCategory
        .addCase(featchFilterDefectCategory.fulfilled, (state, action) => {
            state.defectCategory.entities = action.payload
        })

        // featchFilterDefectType
        .addCase(featchFilterDefectType.fulfilled, (state, action) => {
            state.defectType.entities = action.payload
        })
    }
})

export const { setTreeData } = filtersSlice.actions

/**
 * @returns {initialState}
 */
export const useFilters = () => useSelector((state) => state.filters);
export const useFilterProduct = () => useSelector((state) => state.filters.product);
export const useFilterDefectCategory = () => useSelector((state) => state.filters.defectCategory);
export const useFilterDefectType = () => useSelector((state) => state.filters.defectType);

// Export the reducer
export default filtersSlice.reducer